export default {
  init() {

  },
  finalize() {

  },
  onLoad() {

  },
  onResize(){

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js